import type { AxiosRequestConfig } from 'axios';

import { BaseClient } from '../../clients';
import { useRequestDefinition } from '../../providers';
import { REQUEST } from '../../types';

export const defineBaseClient = useRequestDefinition<BaseClient, AxiosRequestConfig, AxiosRequestConfig>({
  id: REQUEST.BASE,
  client: BaseClient,
  options: Object.create(null),
});
